var React = require('react');

function EmailSubscribe (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"48","cy":"48","r":"48","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M77.9296 29.1468L47.8906 48.9842L17.928 29.1972C18.2609 29.0698 18.6223 29 19 29H77C77.3245 29 77.6369 29.0515 77.9296 29.1468ZM79.9425 31.4126L48.7172 52.0334L47.8906 52.5793L47.064 52.0334L16.0347 31.542C16.0119 31.6914 16 31.8443 16 32V63C16 64.6569 17.3431 66 19 66H77C78.6569 66 80 64.6569 80 63V32C80 31.799 79.9802 31.6026 79.9425 31.4126Z","fill":"#BFBFBF","key":1})]);
}

EmailSubscribe.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = EmailSubscribe;

EmailSubscribe.default = EmailSubscribe;
